import Button from '@/features/marketing/components/Button';
import React, { ReactElement } from 'react';
import searchIcon from '@/assets/icons/front/search-icon.svg';
import Image from 'next/image';

type Props = {};

const ShipmentTrackingForm : React.FC<Props> = () : ReactElement | null => {
    return (
        <form
            className='flex flex-row grow lg:grow-0 items-center justify-center gap-[20px] h-fit bg-[#F5F7FC] rounded-[40px] px-[20px] py-[14px]'
        >
            <Button type='empty' className='focus:outline-0 !px-0' onClick={(event : any) => {
                event.preventDefault();
            }}>
                <Image src={searchIcon} alt='Search Icon' width='16' height='16' />
            </Button>

            <div>
                <input
                    type='text'
                    placeholder='Číslo zásilky'
                    className='p-0 bg-transparent border-none focus:ring-0 focus:border-0 focus:outline-0 placeholder:text-[#5F7194] text-[#5F7194] text-[18px] leading-[24px] lg:w-[10rem]'
                />
            </div>
        </form>
    );
};

export default ShipmentTrackingForm;
